// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

export const SOREN_AUTHOR_OBJECT = {
  name: "Soren Frederiksen",
  link: "https://www.theage.com.au/by/soren-frederiksen-h0fwvz",
  image:
    "https://lh5.googleusercontent.com/-TVlUfW4EG28/AAAAAAAAAAI/AAAAAAAAAIw/cFml0Yhy_-A/photo.jpg"
};

const description =
  "An interactive that aims to deepen our crime coverage, keeping current and trend data at the finger-tips of our reporters.";

const CONFIG: InteractivesMenuItemConfig = {
  author: SOREN_AUTHOR_OBJECT,
  name: "Crime spotlight",
  id: "crime-spotlight",
  linkPrefix: "/interactives",
  tags: ["Crime", "Data viz", "Configurable"],
  description,
  image: DisplayImage,
  adminOnly: false,
  cradleIframeUrlRoot:
    "https://www.theage.com.au/interactive/2018/crime-spotlight/?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "CrimeSpotlightConfigTool" */ "app/components/tools/CrimeSpotlightConfigTool/CrimeSpotlightConfigTool"),
    loading: DynamicImportLoader,
    modules: ["CrimeSpotlightConfigTool"]
  })
};

export default CONFIG;
